import PropTypes from 'prop-types';
import { setClassNames } from 'ddc-classnames-js';
import { useLabels } from 'wsm-common-data';

const ModernMyCarsDetails = ({ link, onClick, isInline, title }) => {
	const labels = useLabels();
	const ariaVehicleTitle = title ? title.join(' ') : '';
	const detailsAriaPreface = labels.get('DETAILS_FOR_THIS');
	const ariaLabel = `${detailsAriaPreface} ${ariaVehicleTitle}`;

	return (
		<a
			className={setClassNames([
				'modern-my-cars-details-label',
				'd-flex',
				'align-items-center',
				'p-0',
				'text-muted',
				isInline ? 'flex-row' : 'flex-column',
				isInline ? 'ml-auto' : ''
			])}
			href={link}
			onClick={onClick}
			aria-label={ariaLabel}
		>
			{!isInline && (
				<i
					aria-hidden="true"
					className="ddc-icon ddc-icon-arrow-details"
				/>
			)}
			<span>{labels.get('DETAILS')}</span>
			{isInline && (
				<i
					aria-hidden="true"
					className="ml-2 ddc-icon ddc-icon-arrow-details"
				/>
			)}
		</a>
	);
};

ModernMyCarsDetails.propTypes = {
	link: PropTypes.string,
	onClick: PropTypes.func,
	isInline: PropTypes.bool,
	title: PropTypes.arrayOf(PropTypes.string)
};

export default ModernMyCarsDetails;
